import { render, staticRenderFns } from "./extra-content.vue?vue&type=template&id=1b1c5c60&"
import script from "./extra-content.vue?vue&type=script&lang=js&"
export * from "./extra-content.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Cristi\\Documents\\Work\\www\\tpdemo\\wp-content\\plugins\\translatepress\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1b1c5c60', component.options)
    } else {
      api.reload('1b1c5c60', component.options)
    }
    module.hot.accept("./extra-content.vue?vue&type=template&id=1b1c5c60&", function () {
      api.rerender('1b1c5c60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/src/js/components/extra-content.vue"
export default component.exports